import React, { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ChevronLeftIcon, ChevronRightIcon, ExpandIcon } from "lucide-react";
import { samples } from "../../data/content";
export function SampleCarousel() {
  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState(1);
  const reduce = useReducedMotion();
  const total = samples.length;
  const s = samples[index];
  const go = (next: number, direction: number) => {
    setDir(direction);
    setIndex((next + total) % total);
  };
  return <section className="border-y border-line bg-cream py-16 md:py-24" aria-roledescription="carousel" aria-label="Pages from the manual" data-id="element-176" data-mp="suj9hhjwevll">
      <div className="mx-auto max-w-wrap px-5 md:px-8" data-id="element-177" data-mp="12myrgev73k6h">
        <h2 className="heading mx-auto max-w-[760px] text-center text-[38px] text-forest md:text-[58px]" data-id="element-178" data-mp="12oi7q5gupv89">
          Take a look <span className="text-sand-deep" data-id="element-179" data-mp="1bn3phyei167z">inside the manual</span>
        </h2>
        <p className="mx-auto mt-4 max-w-[560px] text-center text-[17px] text-muted" data-id="element-180" data-mp="1bl11tl0tjp6f">
          Real pages from Everyday Bags — a selection, not the full manual.
        </p>

        <div className="mt-10 grid items-center gap-8 md:mt-14 md:grid-cols-[minmax(0,380px)_1fr] md:gap-14" data-id="element-181" data-mp="12vyeis40ux4g">
          <div className="relative mx-auto w-full max-w-[340px] overflow-hidden rounded-2xl border border-line bg-ivory shadow-[0_20px_44px_rgba(30,46,37,0.18)] md:max-w-[380px]" data-id="element-182" data-mp="xyotrprkv9my">
            <AnimatePresence mode="popLayout" initial={false} custom={dir} data-id="element-183" data-mp="1qlsrras96np8">
              <motion.div key={index} initial={reduce ? {
              opacity: 0
            } : {
              opacity: 0,
              x: dir * 40
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={reduce ? {
              opacity: 0
            } : {
              opacity: 0,
              x: dir * -40
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} drag="x" dragConstraints={{
              left: 0,
              right: 0
            }} dragElastic={0.2} onDragEnd={(_, info) => {
              if (info.offset.x < -60) go(index + 1, 1);else if (info.offset.x > 60) go(index - 1, -1);
            }} className="aspect-[1448/2592] w-full cursor-grab active:cursor-grabbing" data-id="element-184" data-mp="1lnr74lf6igbn">
                <img src={s.image} alt={`Manual page: ${s.title}`} className="h-full w-full object-contain" draggable={false} data-id="element-185" data-mp="3p4ntbyfr47jw" />
              </motion.div>
            </AnimatePresence>
          </div>

          <div data-id="element-186" data-mp="3g2y2outp1cn6">
            <p className="font-display text-xl font-bold tracking-wide text-sand-deep" aria-live="polite" data-id="element-187" data-mp="3g6lwzw6yq32y">
              {String(index + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
            </p>
            <h3 className="heading mt-2 text-[36px] text-forest md:text-[48px]" data-id="element-188" data-mp="3b54xa407smny">{s.title}</h3>
            <p className="mt-3 max-w-[460px] text-[17px] leading-relaxed text-charcoal" data-id="element-189" data-mp="3b6zg9crxe4pe">{s.body}</p>
            <a href={s.image} target="_blank" rel="noreferrer" className="mt-2 inline-flex items-center gap-1.5 text-sm font-semibold text-forest underline underline-offset-4 hover:text-sand-deep" data-id="element-190" data-mp="14cvnay25smkw">
              <ExpandIcon className="h-4 w-4" aria-hidden="true" data-id="element-191" data-mp="2oyai293g8ana" />
              View page full size
            </a>
            <div className="mt-8 flex items-center gap-3" data-id="element-192" data-mp="33nqarumjiq5m">
              <button type="button" onClick={() => go(index - 1, -1)} aria-label="Previous page" className="flex h-12 w-12 items-center justify-center rounded-full border border-forest/30 text-forest transition-colors duration-150 hover:border-forest hover:bg-forest hover:text-cream" data-id="element-193" data-mp="2ytvqoq30w960">
                <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-194" data-mp="3hloabtw7ci12" />
              </button>
              <button type="button" onClick={() => go(index + 1, 1)} aria-label="Next page" className="flex h-12 w-12 items-center justify-center rounded-full border border-forest/30 text-forest transition-colors duration-150 hover:border-forest hover:bg-forest hover:text-cream" data-id="element-195" data-mp="1s66zrg2pxiwi">
                <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-196" data-mp="j7p1q7ojs652" />
              </button>
              <div className="ml-3 flex gap-2" data-id="element-197" data-mp="o9eebrrf4rv9">
                {samples.map((x, i) => <button key={x.title} type="button" onClick={() => go(i, i > index ? 1 : -1)} aria-label={`Go to page ${i + 1}`} aria-current={i === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 ${i === index ? "w-6 bg-forest" : "w-2 bg-forest/25"}`} data-id="element-198" data-mp="s9ojj27dze92" data-mpi={i} />)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}